module.exports = __webpack_public_path__ + "static/social-faqs-7a60defc60258e3f223c452252d8e3be.jpg";